import { Directive } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[ngModel][jhiIgnoreDirty]'
})

export class IgnoreDirtyDirective {
    constructor(private control: NgControl) {
        this.control.valueChanges.subscribe(() => {
            if (this.control.dirty) {
                this.control.control.markAsPristine();
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/directives/ignore-dirty.directive.ts